
export const checkValueQ=(setting,permistionInv,type,oldVal)=>{
    if (permistionInv.SIM == false &&
        oldVal < 1 && type != 4 &&
        (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
            return 0;
        }else return 1;
};

export const getAlertValQ=(valueSafes,ibance,totValbef,perc)=>{
    alert(
        `
الكمية المدخلة للصنف أكبر من رصيد المخزن
الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(perc))
        }
رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
        }
`
    );
    return 0;
};